module.exports = __webpack_public_path__ + "img/team-2.d0b756bd.jpg";